import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'data-elements'

const api = new ApiCore({
	index: true,
	url: url
})

// Caller passes the runtime DSV_ENABLED flag (sourced from state.auth.features,
// same gate as the sidebar tab) so this stays consistent with the rest of the
// app instead of forking on the static env map.
const dictionaryListPath = (isDSVEnabled) =>
	isDSVEnabled ? 'data-dictionary-active' : 'data-dictionary'
const dictionaryDetailsPath = (id, isDSVEnabled) =>
	isDSVEnabled ? `${id}/datafields-active` : `${id}/datafields`

api.index = (params, isDSVEnabled = false) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${dictionaryListPath(isDSVEnabled)}?${params}`)
		.then(handleResponse)
		.catch(handleError);
}

api.indexDetails = (params, isDSVEnabled = false) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${dictionaryDetailsPath(params, isDSVEnabled)}`)
		.then(handleResponse)
		.catch(handleError);
}

export default api
